// extracted by mini-css-extract-plugin
export default {"divImage":"NotFound_divImage__7v-UD","notFoundImage":"NotFound_notFoundImage__xKNb6"};